import { useState } from "react";
import CatModal from "components/modals/CatModal";
import { Btn, Card } from "components/ui/index";
import { T } from "theme/index";

// ── Kategori ──────────────────────────────────────────────────────────────────
export default function Kategori({ categories, onAdd, onEdit, onDelete }) {
  const [modal, setModal] = useState(null);
  const [tab, setTab]     = useState("expense");
  const filtered = categories.filter(c=>c.type===tab);

  return (
    <div>
      {modal && <CatModal cat={modal==="add"?null:modal} onSave={modal==="add"?onAdd:onEdit} onClose={() => setModal(null)} />}
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
        <div style={{ display:"flex", gap:8, flexWrap:"wrap" }}>
          {[["expense","💸 Keluar"],["income","💰 Masuk"],["investasi","📈 Investasi"]].map(([v,l]) => (
            <button key={v} onClick={() => setTab(v)} style={{ padding:"8px 14px", borderRadius:8, cursor:"pointer", fontWeight:700, fontSize:13, background:tab===v?T.gold+"1E":T.surface, border:`1px solid ${tab===v?T.gold:T.border}`, color:tab===v?T.gold:T.muted, WebkitTapHighlightColor:"transparent" }}>{l}</button>
          ))}
        </div>
        <Btn onClick={() => setModal("add")} style={{ fontSize:12, padding:"8px 12px" }}>＋ Tambah</Btn>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))", gap:10 }}>
        {filtered.map(cat => (
          <Card key={cat.id} style={{ padding:14, display:"flex", flexDirection:"column", gap:10 }}>
            <div style={{ display:"flex", alignItems:"center", gap:10 }}>
              <div style={{ width:40, height:40, borderRadius:10, background:cat.color+"22", display:"flex", alignItems:"center", justifyContent:"center", fontSize:20, flexShrink:0 }}>{cat.icon}</div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ color:T.text, fontWeight:600, fontSize:13, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{cat.name}</div>
                <div style={{ display:"flex", alignItems:"center", gap:4, marginTop:3 }}>
                  <div style={{ width:8, height:8, borderRadius:2, background:cat.color }} />
                  <span style={{ color:T.muted, fontSize:10 }}>{cat.color}</span>
                </div>
              </div>
            </div>
            <div style={{ display:"flex", gap:6 }}>
              <button onClick={() => setModal(cat)} style={{ flex:1, background:T.surface, border:`1px solid ${T.border}`, borderRadius:6, color:T.muted, cursor:"pointer", padding:"6px", fontSize:13, WebkitTapHighlightColor:"transparent" }}>✏️ Edit</button>
              <button onClick={() => { if(window.confirm("Hapus?")) onDelete(cat.id); }} aria-label={`Hapus kategori ${cat.name}`} style={{ background:T.red+"15", border:`1px solid ${T.red}28`, borderRadius:6, color:T.red, cursor:"pointer", padding:"6px 8px", fontSize:13, WebkitTapHighlightColor:"transparent" }}>🗑️</button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
